export default {
	setListener(state, listener) {
		state.listener = listener;
	},
	setJobs(state, jobs) {
		state.jobs = jobs;
	},
	pushJob(state, job) {
		state.jobs.data.unshift(job);
		if (state.jobs.data.length > state.jobs.meta.per_page) {
			state.jobs.data.pop();
		}
		state.jobs.meta.total++;
	},
	updateJob(state, job) {
		state.jobs.data = state.jobs.data.map(item => item.id === job.id ? job : item);
	},
};
